<template>
  <div class="scrollable">
  	<v-header></v-header>
    <div class="content">
    	<div class="breadNav">
        <P>{{$t('m.staffHosDetail.brankNav')}}</P>
      </div>
      <div class="hospitalName">
        <p class="icon"></p>
        <p class="name">{{$t('m.staffHosDetail.hos')}}：{{datajson.name}}</p>
      </div>
      <div class="map" id="XSDFXPage"></div>
      <div class="mapMsg">
          <p><span>{{$t('m.staffHosDetail.address')}} :</span><span> {{datajson.address}} </span></p>
          <p><span>{{$t('m.staffHosDetail.time')}} : </span><span>{{datajson.work_time}}</span></p>
          <p><span>{{$t('m.staffHosDetail.phone')}} : </span><span>{{datajson.inst_contact}} </span></p>
          <p><span>{{$t('m.staffHosDetail.msg')}} :</span><span> {{datajson.description}} </span></p>
          <p><span>{{$t('m.staffHosDetail.line')}} : </span><span>{{datajson.traffic_route}}</span></p>
      </div>
      <div class="back" @click="backBtn">
        <p>{{$t('m.common.goBack')}}</p>
      </div>
    </div>
  	<v-footer></v-footer>
  </div>
</template>

<script>
import axios from 'axios'; 
import {mapActions, mapGetters} from 'vuex';
import header from '../../common/header.vue'  
import footer from '../../common/footer.vue'  
export default {
	name: 'hospitalDetails',
	data () {
	    return {
	       datajson:{}
	    }
  	},
  	components: {
	    "v-header": header,
	    "v-footer":footer
	  },
    mounted() {
       this.getHosMsg();
    },
  	created() {
  		
    },
  	methods:{
  		backBtn(){
        let _this = this;
        _this.$router.go(-1);
      },
      getHosMsg(){
        let _this = this;
        let id = _this.$route.query.id;
        //获取套餐详情接口
        axios.get(BASE_URL+'/exam/hospitals/'+id+'/').then((res)=>{
          console.log(res);
          _this.datajson = res.data.data;
          this.setMap();
        })
        
      },
      setMap(){
           //创建Map实例
            var map = new BMap.Map("XSDFXPage");
           // 初始化地图,设置中心点坐标
            var point = new BMap.Point(parseFloat(this.datajson.longitude),parseFloat(this.datajson.latitude));// 创建点坐标
            map.centerAndZoom(point,15);
            //添加鼠标滚动缩放
            map.enableScrollWheelZoom();

            //添加缩略图控件
            map.addControl(new BMap.OverviewMapControl({isOpen:false,anchor:BMAP_ANCHOR_BOTTOM_RIGHT}));
            //添加缩放平移控件
            map.addControl(new BMap.NavigationControl());
            //添加比例尺控件
            map.addControl(new BMap.ScaleControl());
            //添加地图类型控件
            //map.addControl(new BMap.MapTypeControl());

            //设置标注的图标
            var icon = new BMap.Icon(require("../../../assets/icon.png"),new BMap.Size(100,100));
            //设置标注的经纬度
            var marker = new BMap.Marker(new BMap.Point(parseFloat(this.datajson.longitude),parseFloat(this.datajson.latitude)),{icon:icon});
            //把标注添加到地图上
            map.addOverlay(marker);
            var content = "<table>";
            // content = content + "<tr><td> 编号：001</td></tr>";
            content = content + "<tr><td> "+this.datajson.name+"</td></tr>";
            // content = content + "<tr><td> 时间：2018-1-3</td></tr>";
            content += "</table>";
            var infowindow = new BMap.InfoWindow(content);
            marker.addEventListener("click",function(){
                this.openInfoWindow(infowindow);
            });

            //点击地图，获取经纬度坐标
           // map.addEventListener("click",function(e){
           //      document.getElementById("aa").innerHTML = "经度坐标："+e.point.lng+" &nbsp;纬度坐标："+e.point.lat;
           //  });
      }

  	},
  	computed: {
  	  // ...mapGetters(['resturantName','resturantId']) // 动态计算属性，相当于this.$store.getters.resturantName
  	}
}
</script>

<style scoped>
  .back{
    width: 1180px;
    height: 46px;
    background: #f2f2f2;
    margin:0 auto;
    margin-top: 20px;
    margin-bottom: 124px;
    display: flex;
    justify-content: flex-end;
  }
  .back p{
    width: 180px;
    height: 46px;
    background: #E51E26;
    font-size:20px;
    
    /*font-weight:600;*/
    color:#fff;
    line-height:20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .mapMsg {
    width: 1180px;
    margin: 0 auto;
    margin-top: 30px;
    padding: 20px;
    border:1px solid #ccc;
  }
  .mapMsg p span:first-child{
    font-size:14px;
    
    font-weight:600;
    color:#333;
    line-height:26px;
  }
  .mapMsg p span:last-child{
    font-size:14px;
    
    font-weight:400;
    color:#333;
    line-height:26px;
  }
  .map{
    width: 1180px;
    height: 300px;
    border: 1px solid #ccc;
    margin: 0 auto;
    margin-top: 30px;
    padding: 20px;
  }
  .map img{
    width: 100%;
    height: 100%;
  }
  .hospitalName{
    width: 1180px;
    height: 78px;
    border:1px solid #ccc;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 30px;
  }
  .hospitalName .icon{
    width: 4px;
    height: 18px;
    background: #e94709;
  }
  .hospitalName .name{
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:18px;
    margin-left: 7px;
  }
  .breadNav{
    width: 100%;
    height: 80px;
    border-bottom: 2px solid #EAEAEA;
    display: flex;
    align-items: center;
  }
  .breadNav p{
    width: 1180px;
    margin: 0 auto;
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/hospitalDetails.vue